module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('v-snackbar', {
    attrs: {
      "app": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    Bienvenue " + _vm._s(_vm.displayName) + " "), _c('span', {
    staticClass: "display-1"
  }, [_vm._v("🤘")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("fermer")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', [(_vm.connected) ? _c('div', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    on: {
      "click": _vm.home
    }
  }, [_vm._v(_vm._s(_vm.displayName))])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("exit_to_app")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.signout()
      }
    }
  }, [_vm._v("Se déconnecter")])], 1)], 1)], 1) : _c('div', [_c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("person")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('router-link', {
    key: _vm.$route.fullPath,
    attrs: {
      "to": "/login"
    }
  }, [_c('v-list-tile-title', [_vm._v("Créer un compte / se connecter")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("map")])], 1), _vm._v(" "), _c('v-list-tile-content', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [(_vm.mapStyle === 'map') ? _c('v-list-tile-title', {
    on: {
      "click": function($event) {
        _vm.mapStyle = 'satelite'
      }
    }
  }, [_vm._v("Passer en vue satellite")]) : _c('v-list-tile-title', {
    on: {
      "click": function($event) {
        _vm.mapStyle = 'map'
      }
    }
  }, [_vm._v("Passer en vue carte")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-action', [_c('v-icon', {
    attrs: {
      "light": ""
    }
  }, [_vm._v("question_answer")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('router-link', {
    attrs: {
      "to": "/apropos"
    }
  }, [_c('v-list-tile-title', [_vm._v("A propos & aide ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "primary",
    staticStyle: {
      "background": "url('static/img/paysage.png') bottom no-repeat",
      "background-size": "contain"
    },
    attrs: {
      "dense": "",
      "dark": "",
      "app": ""
    }
  }, [_c('v-toolbar-side-icon', {
    attrs: {
      "dark": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', {
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "id": "toolbarTitle"
    },
    domProps: {
      "textContent": _vm._s(_vm.title)
    },
    on: {
      "click": _vm.home
    }
  }), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "app": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.welcomeDialog),
      callback: function($$v) {
        _vm.welcomeDialog = $$v
      },
      expression: "welcomeDialog"
    }
  }, [_c('v-card', [_c('v-img', {
    attrs: {
      "src": "/static/img/aire-de-jeux.jpg",
      "height": "200px"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Bienvenue sur Parc Épique !")]), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, [_vm._v("Une carte\n            "), _c('span', {
    staticClass: "strong"
  }, [_vm._v("collaborative")]), _vm._v(" de toutes les aires de jeux pour enfants de France.\n          ")])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "large": "",
      "color": "primary"
    },
    on: {
      "click": function($event) {
        _vm.welcomeDialog = false
      }
    }
  }, [_vm._v("C'est parti 🚀")]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Ne plus montrer",
      "color": "primary"
    },
    model: {
      value: (_vm.dontShowAnyMore),
      callback: function($$v) {
        _vm.dontShowAnyMore = $$v
      },
      expression: "dontShowAnyMore"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-content', [_c('router-view', {
    attrs: {
      "map-style": _vm.maps[_vm.mapStyle]
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5cfe7ed7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 456
// module chunks = 1